import axios from "axios";
import { get } from "lodash";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  REQUEST_MASTER_COMMUNITY,
  REQUEST_CREATE_MASTER_COMMUNITY,
  SET_MASTER_COMMUNITY,
  SUCCESS_CREATE_MASTER_COMMUNITY,
  ERROR_GET_MASTER_COMMUNITY,
  ERROR_CREATE_MASTER_COMMUNITY,
  SUCCESS_DELETE_MASTER_COMMUNITY,
  SUCCESS_UPDATE_MASTER_COMMUNITY,
  REQUEST_DELETE_MASTER_COMMUNITY,
  REQUEST_UPDATE_MASTER_COMMUNITY,
  ERROR_DELETE_MASTER_COMMUNITY,
  ERROR_UPDATE_MASTER_COMMUNITY,
} from "./communityActionTypes";

function* requestMasterCommunity(action: Record<string, any>): any {
  try {
    const result: any = yield call(getCommunityMaster);
    yield put({ type: SET_MASTER_COMMUNITY, payload: result.data.data });
    // console.warn(result.data.data, "jhuihihi");
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_GET_MASTER_COMMUNITY, payload: message });
  }
}

function* requestUpdateMasterTagCommunity(action: Record<string, any>): any {
  try {
    const result = yield call(
      updateMasterCommunity,
      action.data.payload,
      action.data._id
    );
    yield put({
      type: SUCCESS_UPDATE_MASTER_COMMUNITY,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_UPDATE_MASTER_COMMUNITY, payload: message });
  }
}

function* requestDeleteMasterTagCommunity(action: Record<string, any>): any {
  try {
    yield call(deleteMasterCommunity, get(action, "payload._id", ""));
    yield put({
      type: SUCCESS_DELETE_MASTER_COMMUNITY,
      payload: get(action, "payload._id", ""),
    });
  } catch (error: any) {
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_DELETE_MASTER_COMMUNITY, payload: message });
  }
}

function* requestCreateMasterCommunity(action: Record<string, any>): any {
  try {
    const result = yield call(createMasterCommunity, action.payload);

    yield put({
      type: SUCCESS_CREATE_MASTER_COMMUNITY,
      payload: result.data.data,
    });
    if (action.onSuccess) action.onSuccess(result);
    // update relevant category as well
  } catch (error: any) {
    console.log(error);
    let message =
      "Something went wrong, please try again after some time or Refresh the Page.";
    if (get(error, "response.status") === 500) {
      message = "Something happened wrong try again after sometime.";
    } else if (get(error, "response.status") === 422) {
      message = error.response.data.message || "please provide valid contain";
    } else if (get(error, "response.status") === 415) {
      message = error.response.data.message;
    }
    yield put({ type: ERROR_CREATE_MASTER_COMMUNITY, payload: message });
  }
}

export function getCommunityMaster() {
  return axios({
    method: "GET",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community`,
    withCredentials: true,
  });
}

export function createMasterCommunity(payload: Record<string, any>) {
  return axios({
    method: "post",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community`,
    data: payload,
    withCredentials: true,
  });
}

export function deleteMasterCommunity(_id: string) {
  return axios({
    method: "delete",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community/${_id}`,
    withCredentials: true,
  });
}
export function updateMasterCommunity(payload: Record<string, any>, _id: string) {
  return axios({
    method: "patch",
    url: `${process.env.REACT_APP_BASE_URL}/admin/community/${_id}`,
    data: payload,
    withCredentials: true,
  });
}

const communityMasterSaga = function* () {
  yield all([
    takeLatest(REQUEST_MASTER_COMMUNITY, requestMasterCommunity),
    takeLatest(REQUEST_CREATE_MASTER_COMMUNITY, requestCreateMasterCommunity),
    takeLatest(REQUEST_UPDATE_MASTER_COMMUNITY, requestUpdateMasterTagCommunity),
    takeLatest(REQUEST_DELETE_MASTER_COMMUNITY, requestDeleteMasterTagCommunity),
  ]);
};

export default communityMasterSaga;
